import { apiCall } from "./service";
import { BASE_URL } from "./URL";
const keyEventsService = {
  createKeyEvent: async (portfolioId, payload) => {
    try {
      const params = {
        url : `${BASE_URL}Portfolios/${portfolioId}/TimeLine-key-event`,
        params: payload
      };
      const response = await apiCall.post(params);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateKeyEvent: async (portfolioId, eventId, payload) => {
    try {
      const params = {
        url : `${BASE_URL}Portfolios/${portfolioId}/TimeLine-key-event/${eventId}`,
        params: payload
      };

      const response = await apiCall.put(params);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteKeyEvent: async (portfolioId, eventId) => {
    try {
      const payload = {
        url : `${BASE_URL}Portfolios/${portfolioId}/TimeLine-key-event/${eventId}`
      };
      const response = await apiCall.delete(payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default keyEventsService;
